import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import Cookies from "js-cookie";

let token = Cookies.get('primaryToken');

export const apiCore = createApi({
    refetchOnMountOrArgChange: 900,
    reducerPath: 'apiCore',
    tagTypes: ['choose-credit-plans', 'get-user-auth-status', 'get-provinces-data', 'get-cities-data', 'fetch-prefilled-details','get-uploaded-docs-data'],
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://accredit.kalamarket.com/api/v1/',
        prepareHeaders: ((headers, {getState, endpoint}) => {
            if (token) {
                headers.set("Authorization", token)
            }
            return headers;
        })
    }),
    endpoints: () => ({})
})

export const apiCoreV2 = createApi({
    refetchOnMountOrArgChange: 900,
    reducerPath: 'apiCoreV2',
    tagTypes: ['choose-credit-plans','get-credit-plans','get-user-auth-status'],
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://accredit.kalamarket.com/api/v2/',
        prepareHeaders: ((headers, {getState, endpoint}) => {
            if (token) {
                headers.set("Authorization", token)
            }
            return headers;
        })
    }),
    endpoints: () => ({})
})